import BaseQuestionModel from '../BaseQuestionModel'

import { IQuestionModelConstructor, QuestionType } from '../types'
import {
  IFeedbackQuestionModelState,
  IFeedbackResponseValidation,
  FeedbackQuestionModelTypes,
  FeedbackResponse,
  FeedbackSubmitResponse
} from './types'

const FeedbackQuestionModel: IQuestionModelConstructor<FeedbackQuestionModelTypes> = (questionSchema, action) => {
  const { model } = BaseQuestionModel<FeedbackQuestionModelTypes, IFeedbackQuestionModelState>({
    questionType: QuestionType.FEEDBACK,
    questionSchema: questionSchema,
    action,
    submitResponse,
    initState,
    validateResponse
  })
  return model
}

export function submitResponse({ response, questionSchema }: IFeedbackQuestionModelState): FeedbackSubmitResponse {
  // comment travels independently of the star — a no-star skip must not drop it (OQ-FB-15)
  const value = response.data[0]?.value
  const answer = value ? questionSchema.matrix_batches[0]?.answers[value - 1] : undefined
  const result: FeedbackSubmitResponse = { data: answer ? [{ id: answer.id }] : [] }
  if (response.comment) {
    result.comment = response.comment
  }
  return result
}

function initState(state: IFeedbackQuestionModelState): IFeedbackQuestionModelState {
  state.response = {
    data: state.questionSchema.matrix_batches.map<FeedbackResponse['data'][number]>(batch => ({
      id: batch.id,
      value: null
    })),
    comment: ''
  }
  return state
}

function validateResponse(): IFeedbackResponseValidation {
  return {
    valid: true
  }
}

export default FeedbackQuestionModel
